import LanguageSelect from "../../components/LanguagesSelect";
import ForgotPassword from "./forgotPassword";

import { useState } from "react";
import i18n from "../../../services/i18n";



export default function Login() {

    const [language, setLanguage] = useState(i18n.language)

    const changeLanguage = (lng) => {
        console.log(`chaning lang: ${lng}`)
        i18n.changeLanguage(lng)
        setLanguage(lng)
    }

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100vw',
                height: '100vh',
                flexDirection: 'column',
                backgroundColor: 'rgba(241, 241, 241, 0.945)'
            }}
            >
            <div
                style={{
                    position: 'absolute',
                    top: 10,
                    right: 20
                }}
            >
                <LanguageSelect
                    changeLanguage={changeLanguage}
                    defaultValue={language}
                />
            </div>
            <ForgotPassword
            />
        </div>
    )
}
